import button from './button';
import skeleton from './skeleton';

const recipeConfigs = [button, skeleton];
export default recipeConfigs;
